export const checkCardAccess = (card, userId) => {
  if (!card || !userId) return { canView: false, canEdit: false };

  // Owner has full access
  if (card.userId === userId) {
    return { canView: true, canEdit: true };
  }

  // Check shared access
  const canEdit = Array.isArray(card.canEdit) && card.canEdit.includes(userId);
  const canView = canEdit || (Array.isArray(card.canView) && card.canView.includes(userId));

  return { canView, canEdit };
}; 